// Subscription management service

import { stripeProductService } from "./stripeProductService";

class SubscriptionService {
  // Static data for subscription-specific fields (not in Stripe)
  getSubscriptionData() {
    return {
      s: {
        id: "s",
        name: "Basic Plan",
        minutes: 90,
        description: "Perfect for occasional missions.",
        badge: null,
        price: 99,
        features: [
          "90 livestreaming minutes / month",
          "Up to 3 remote guests",
          "Group audio call",
          "Private, secure rooms",
          "Flight logs",
        ],
      },
      m: {
        id: "m",
        name: "Standard Plan",
        minutes: 300,
        description: "Ideal for regular drone operations.",
        badge: "POPULAR",
        price: 299,
        features: [
          "300 livestreaming minutes / month",
          "Up to 5 remote guests",
          "Group audio call",
          "Private, secure rooms",
          "Flight logs",
        ],
      },
      l: {
        id: "l",
        name: "Premium Plan",
        minutes: 600,
        description: "Best for power users and agencies.",
        price: 499,
        badge: null,
        features: [
          "600 livestreaming minutes / month",
          "Up to 8 remote guests",
          "Group audio call",
          "Private, secure rooms",
          "Flight logs",
        ],
      },
    };
  }

  getProductIds() {
    return {
      s: "prod_TTqoPIYxflRKEZ",
      m: "prod_TTqr1NRK9q3Z2X",
      l: "prod_TTqtHssPmLRomB",
      // s: "prod_TK5vX96wt46HZS",
      // m: "prod_TK63iUVKuxzBI8",
      // l: "prod_TK63iD8lusn0zt",
    };
  }

  async getPlans() {
    // Fetch Stripe price data for each plan
    const productIds = this.getProductIds();
    const subscriptionData = this.getSubscriptionData();
    const plans = await Promise.all(
      Object.keys(productIds).map(async (planKey) => {
        const productId = productIds[planKey];
        const staticData = subscriptionData[planKey];

        // Fetch price from Stripe
        const stripeData = await stripeProductService.fetchProductDetails(
          productId
        );

        // Merge Stripe price with static plan data
        return {
          ...staticData,
          price: stripeData.price,
          priceId: stripeData.priceId,
          stripeProductId: productId,
        };
      })
    );

    return plans;
  }

  async handleSubscription(
    plan,
    userId,
    activeSubscriptionId = null,
    activeSubscriptionStripeId = null
  ) {
    // Create Stripe subscription session via backend
    const successUrl = `${window.location.origin}/subscriptions?status=success&plan=${plan.id}`;
    const cancelUrl = `${window.location.origin}/subscriptions?status=cancelled&plan=${plan.id}`;

    const response = await fetch(
      // "http://localhost:3001/v1/payments/create-subscription-session",
      "https://skyhost.ai/create-subscription-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productId: plan.stripeProductId,
          successUrl,
          cancelUrl,
          planId: plan.id,
          userId: userId,
          planName: plan.name,
          activeSubscriptionId: activeSubscriptionId,
          activeSubscriptionStripeId: activeSubscriptionStripeId,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    const result = await response.json();
    if (!result.status || !result.data?.sessionUrl) {
      throw new Error(
        result.message || "Failed to create subscription session"
      );
    }

    // Redirect to Stripe checkout
    window.location.href = result.data.sessionUrl;
  }

  async cancelSubscription(
    userId,
    activeSubscriptionId = null,
    activeSubscriptionStripeId = null,
    reason = "user_requested"
  ) {
    console.log("activeSubscriptionId", activeSubscriptionId);
    console.log("activeSubscriptionStripeId", activeSubscriptionStripeId);
    console.log("reason", reason);

    const response = await fetch(
      // "http://localhost:3001/v1/payments/cancel-subscription",
      "https://skyhost.ai/cancel-subscription",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subscriptionId: activeSubscriptionId || undefined,
          stripeSubscriptionId: activeSubscriptionStripeId || undefined,
          reason,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    const result = await response.json();
    return result;
  }
}

export const subscriptionService = new SubscriptionService();
export default subscriptionService;
